import type { KpiData } from "@tracify/shared";

export const ACQUISITION_ROAS_METRIC =
  "acquisition_return_on_ad_spend" as const;

export type AcquisitionRoasMetric = {
  [ACQUISITION_ROAS_METRIC]: number;
};

/**
 * Acquisition ROAS always represents the new-customer ROAS, regardless of the
 * customer type currently selected in the dashboard.
 */
export const getAcquisitionRoas = (data?: Pick<KpiData, "new">): number =>
  data?.new?.return_on_ad_spend ?? 0;
